var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgEllipsisVertical(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M9 10.688a1.688 1.688 0 100-3.376 1.688 1.688 0 000 3.375zM9 16.313a1.687 1.687 0 100-3.375 1.687 1.687 0 000 3.374zM9 5.063a1.688 1.688 0 100-3.376 1.688 1.688 0 000 3.375z",
    fill: "#F7F7F7"
  })));
}
export default SvgEllipsisVertical;